/* import __COLOCATED_TEMPLATE__ from './standard-content-tab.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();